module.exports = {
	"name": "Maxim Siebert",
	"icons": [
		{
			"src": "/android-chrome-72x72.png",
			"sizes": "72x72",
			"type": "image/png"
		}
	],
	"theme_color": "#ffffff",
	"background_color": "#ffffff",
	"display": "standalone"
};


//////////////////
// WEBPACK FOOTER
// ./images/manifest.json
// module id = 498
// module chunks = 0